import React from 'react'
import styled from 'styled-components'

import { Panel } from 'components/Panel'
import { Disconnected, screenSize } from 'styles/shared'

type Props = {
  title: string
  type: 'preview' | 'normal'
}

const ExtendedDisconnect = ({ title, type }: Props) => {
  return (
    <S.Panel $type={type}>
      <Panel.Header>
        <Panel.Title>{title}</Panel.Title>
      </Panel.Header>
      <S.DisconnectedContainer>
        <S.Disconnected $type={type}>
          <h1>Disconnected</h1>
          <h2>
            Data cannot be displayed because this device has been disconnected for more than 2 days.
            Please reach out to the customer to have them reconnect their device.
          </h2>
        </S.Disconnected>
      </S.DisconnectedContainer>
    </S.Panel>
  )
}

export default ExtendedDisconnect

const S = {
  Panel: styled(Panel) <{ $type: 'preview' | 'normal' }>`
    scroll-margin-top: 60px;

    ${({ $type }) => $type === 'preview' && 'border-bottom: 0;'}

    @media ${screenSize.small}, ${screenSize.medium} {
      width: 100%;
    }
  `,
  DisconnectedContainer: styled.div`
    display: flex;
    flex-direction: column;
    padding: 20px 0 55px 0;
  `,
  Disconnected: styled(Disconnected) <{ $type: 'preview' | 'normal' }>`
    ${({ $type }) => $type === 'preview' && `
      h1 {
        font-size: 28px;
      }
      h2 {
        font-size: 12px;
      }
    `}
  `
}
